import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: linear-gradient(to right, rgb(255, 255, 255) 40%, transparent 60%)
    0% 0% / 100%;
  background: transparent
    linear-gradient(180deg, #ffffff 0%, #ffffff64 61%, #ffffff00 100%) 0% 0%
    no-repeat padding-box;
  transform: matrix(-1, 0, 0, -1, 0, 0);
  position: absolute;
  bottom: 0;
  z-index: -1;
  height: 18.1rem;
`;
